import fetch from 'node-fetch'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

// 'https://graphql.youguoquan.com/graphql' :
// 'https://gapi-test.youguoquan.com/graphql';

// 'https://apiv10.youguoquan.com/graphql':
// 'https://apiv10.youguoquan.com/graphql';

let base_url = process.env.NODE_ENV === 'production' ?
  'https://apiv10.youguoquan.com/graphql':
  'https://apiv10-test.youguoquan.com/graphql';
const httpLink = new HttpLink({
  uri: base_url,
  fetch: fetch,
  credentials: 'same-origin'
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

export default new VueApollo({
  defaultClient: apolloClient,
  clients: { default: apolloClient }
})



// WEBPACK FOOTER //
// ./src/graphql/apollo.js